
import * as modals from "../../../lib/modals";
import Component from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import ModalMixin from "./mixin";
import InventoryTransactionTable from "@/components/barcodeSystem/inventory/InventoryTransactionTable.vue";
import InventoryItem from "@/components/barcodeSystem/inventory/InventoryItem.vue";
import { InventoryItemResource, UpdateInventoryItemRequest, ResolveMissingInventoryItemRequest, DeleteInventoryItemRequest  } from "@/models/api/barcodeSystem/inventory/inventoryItems";
import notifications from "@/lib/notifications";

const inventoryModuleState = getModule(InventoryModule);

@Component({
  name: modals.inventoryItemViewModal,
  components: {
    InventoryItem,
    InventoryTransactionTable
  }
})
export default class InventoryItemViewModal extends ModalMixin {
  loadingComplete: boolean = false;
  loadingTransactions: boolean = false;
  isSaving: boolean = false;
  isDeleting: boolean = false;
  showTransLogsModal: boolean = false;
  showDeleteInventoryItemModal: boolean = false;
  deleteReason: string = null;

  async load() {
    this.loadingComplete = false;
    this.show();
    try
    {
      inventoryModuleState.resetInventoryTransactions();
      await inventoryModuleState.loadInventoryItem(this.selectedItem.id);
    } catch (ex) {
      notifications.error("Failed to load inventory item", "Failed to load inventory item.", ex);
      this.hideModal();
    }
    this.loadingComplete = true;
  }

  get currentInventoryItem() : InventoryItemResource
  {
    return inventoryModuleState.currentInventoryItem;
  }

  async deletePrompt()
  {
    if(this.currentInventoryItem){
      if(this.currentInventoryItem.orderId){
        notifications.error("Cannot Delete", "This item is currently linked to an order.  The item must be removed from the order before it can be deleted.");
        return;
      }
      this.showDeleteInventoryItemModal=true;
    }
  }  

  closeModals()
  {
    this.showTransLogsModal=false;
    this.showDeleteInventoryItemModal=false;
  }

  async showTransLog(){
    if(this.currentInventoryItem)
    {
      this.loadingTransactions = true;
      this.showTransLogsModal=true;
      try {
        await inventoryModuleState.getInventoryTransactionsForInventoryItem();
      } catch (error) {
        notifications.error(
          "Inventory Item Transactions Failed",
          error.response.data.message
        );
      }   
      finally{
        this.loadingTransactions = false;
      }
    }
  }

  async saveInventoryItem(){
    if(this.currentInventoryItem)
    {
      this.isSaving = true;
      try {
        let request = {
          id: this.currentInventoryItem.id,
          facilityCode: this.currentInventoryItem.facilityCode,
          companyId: this.currentInventoryItem.companyId,
          manufacturerCode: this.currentInventoryItem.manufacturerCode,
          itemType: this.currentInventoryItem.itemType,
          itemScan: this.currentInventoryItem.itemScan,
          serialNumber: this.currentInventoryItem.serialNumber,
          modelNumber: this.currentInventoryItem.modelNumber,
          poNumber: this.currentInventoryItem.poNumber,
          returned: this.currentInventoryItem.returned,
          returnReason: this.currentInventoryItem.returnReason,
          isDamaged: this.currentInventoryItem.isDamaged,
          damageCode: this.currentInventoryItem.damageCode,
          quantity: this.currentInventoryItem.quantity,
          raNumber: this.currentInventoryItem.raNumber,
          auctionNumber: this.currentInventoryItem.auctionNumber,
          disposalNumber: this.currentInventoryItem.disposalNumber,
          warehouseLocationId: this.currentInventoryItem.warehouseLocationId,
          palletId: this.currentInventoryItem.palletId,
          shrinkage: this.currentInventoryItem.shrinkage,
          returnComment: this.currentInventoryItem.returnComment,
          itemDescription: this.currentInventoryItem.itemDescription,
          sku: this.currentInventoryItem.sku
        } as UpdateInventoryItemRequest;

        await inventoryModuleState.updateInventoryItem(request);
        notifications.success("Inventory Item Saved", "Inventory item successfully saved.");
        await this.reloadInventoryItem();
      } catch (error) {
        notifications.error(
          "Inventory Item Save Failed",
          error.response.data.message
        );
      }   
      finally{
        this.isSaving = false;
      }
    }
  }

  async deleteInventoryItem(){
    if(this.currentInventoryItem)
    {
      this.isDeleting = true;
      try {
        let request = {
            id: this.currentInventoryItem.id,
            deleteReason: this.deleteReason
        } as DeleteInventoryItemRequest;
        await inventoryModuleState.deleteInventoryItem(request);
        inventoryModuleState.removeInventoryItemData(this.currentInventoryItem);
        inventoryModuleState.setCurrentInventoryItem(null);
        notifications.success("Inventory Item Deleted", "Inventory item successfully deleted.");
        this.hideModal();
      } catch (error) {
        notifications.error(
          "Inventory Item Delete Failed",
          error.response.data.message
        );
      }   
      finally{
        this.isDeleting = false;
      }
    }
  }

  async reloadInventoryItem(){
    this.loadingComplete = false;
    await inventoryModuleState.reloadInventoryItem();
    this.loadingComplete = true;
  }

  reset() {
    this.closeModals();
    this.loadingComplete = false;
    this.deleteReason = '';
  }
}
